module.exports = __webpack_public_path__ + "img/wordBg1.34702cb4.png";